<template>
  <div id="store-service" class="content-section">
    <div class="section-title">租车权益</div>
    <div class="section-content">
      <div class="info-rows">
        <template v-if="lists.length">
          <div
            class="info-row"
            v-for="(item, index) in lists"
            :key="index"
          >
            <div class="info-label">{{ item.title }}：</div>
            <div class="info-value">{{ item.content || '--' }}</div>
          </div>
        </template>
        <div v-else class="empty-tip">暂无租车权益</div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  storeServices: {
    type: Array,
    default: () => [],
  },
})

const lists = computed(() => {
  return props.storeServices?.filter((item) => item.selected === 1) || []
})
</script>

<style lang="scss" scoped>
.content-section {
  background: #ffffff;
  border-radius: 12px;
  margin-bottom: 16px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);

  .section-title {
    font-size: 16px;
    font-weight: 500;
    color: #333333;
    padding: 16px 20px;
  }

  .section-content {
    padding: 20px;
  }

  .info-rows {
    display: flex;
    flex-direction: column;
    gap: 16px;

    .empty-tip {
      color: #999;
      text-align: center;
      padding: 16px 0;
    }

    .info-row {
      display: flex;

      .info-label {
        color: rgba(0, 0, 0, 0.6);
        font-size: 14px;
        flex-shrink: 0;
      }

      .info-value {
        color: #333333;
        font-size: 14px;
        flex: 1;
        word-break: break-all;
      }

      .highlighted-text {
        background-color: #e6f7ff;
        border: 1px solid #91d5ff;
        border-radius: 4px;
        padding: 0 4px;
        color: #1890ff;
        display: inline-block;
      }
    }
  }
}
</style>
